<template>
  <el-form :model="categoriesForm" :rules="rules" label-width="17%" v-loading.body="fetchLoding" class="demo-categoriesForm">
    <el-form-item :label="generateCustomizeString('categoriesName')" prop="name">
      <el-input v-model="categoriesForm.name"></el-input>
    </el-form-item>

    <el-form-item :label="generateCustomizeString('categoriesParent')" prop="parent_id">
      <el-select v-model="categoriesForm.parent_id" :placeholder="generateCustomizeString('topCategory')">
        <el-option v-for="item in categoriesData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <span>{{ generateCustomizeString('noCategoriesParent') }}</span>
    </el-form-item>

    <el-form-item :label="generateCustomizeString('categoriesDescription')" prop="desc">
      <el-input v-model="categoriesForm.desc"></el-input>
    </el-form-item>

    <el-form-item :label="generateCustomizeString('categoriesSortWeight')" prop="sort_by">
      <el-input v-model="categoriesForm.sort_by" min="0" max="999" type="number" @change="setInt()"></el-input>
    </el-form-item>

    <el-form-item :label="generateCustomizeString('pcHomeCategoryImage')" prop="pc_home_img_key">
      <el-upload
        action="https://upload-z2.qiniup.com"
        :limit="1"
        :drag="true"
        :on-success="handleAvatarSuccess"
        :on-error="handleError"
        :before-upload="beforeAvatarUpload"
        :data="qiniuData"
      >
        <img v-if="pcHomeImgUrl" :src="displayPcHomeCategoryImg" />
        <div v-else>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{ generateCustomizeString('dragFiles') }}
            <em>{{ generateCustomizeString('uploadFiles') }}</em>
          </div>
        </div>
        <div
          class="el-upload__tip"
          slot="tip"
        >{{ generateCustomizeString('fileLimit') }}, {{ generateCustomizeString('pcHomeCategoryImageSize') }}</div>
      </el-upload>
      <el-button v-if="pcHomeImgUrl" type="text" @click="deletePcImage">
        {{ generateCustomizeString('deleteImage') }}
      </el-button>
    </el-form-item>

    <el-form-item :label="generateCustomizeString('mobileCategoryImage')" prop="mobile_category_img_key">
      <el-upload
        action="https://upload-z2.qiniup.com"
        :limit="1"
        :drag="true"
        :on-success="handleMobileAvatarSuccess"
        :on-error="handleError"
        :before-upload="beforeAvatarUpload"
        :data="qiniuData"
      >
        <img v-if="mobileImgUrl" :src="displayMobileCategoryImg" />
        <div v-else>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{ generateCustomizeString('dragFiles') }}
            <em>{{ generateCustomizeString('uploadFiles') }}</em>
          </div>
        </div>
        <div
          class="el-upload__tip"
          slot="tip"
        >{{ generateCustomizeString('fileLimit') }}, {{ generateCustomizeString('mobileCategoryImageSize') }}</div>
      </el-upload>
      <el-button v-if="mobileImgUrl" type="text" @click="deleteMobileImage">
        {{ generateCustomizeString('deleteImage') }}
      </el-button>
    </el-form-item>

    <el-form-item :label="generateCustomizeString('category_icon')" prop="icon_name">
      <el-select  v-model="categoriesForm.icon_name" @change="selectCategoryIcon">
        <el-option v-for="item in iconOptions" :key="item.value" :label="' ' + item.label" :value="item.value" :class="item.class">
        </el-option>
      </el-select>
      &nbsp;&nbsp;<i v-bind:class="'iconfont ' + categoriesForm.icon_name" style="font-size: 26px; vertical-align: middle;"></i>
      <span style="margin-left: 10px;">
        <el-checkbox v-model="customizeIconChecked" @change="handleCustomizeIcon">{{ generateCustomizeString('customizeIcon') }}</el-checkbox>
      </span>
    </el-form-item>
    <el-form-item v-if="uploadIconShow" :label="generateCustomizeString('customizeIcon')" prop="icon_img_key">
      <el-upload
        action="https://upload-z2.qiniup.com"
        :limit="1"
        :drag="true"
        :on-success="handleCustomizeIconSuccess"
        :on-error="handleError"
        :before-upload="beforeAvatarUpload"
        :data="qiniuData"
      >
        <img v-if="iconImgUrl" :src="displayIconImg" />
        <div v-else>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{generateCustomizeString('dragFiles')}}
            <em>{{generateCustomizeString('uploadFiles')}}</em>
          </div>
        </div>
        <div
          class="el-upload__tip"
          slot="tip"
        >{{generateCustomizeString('fileLimit')}}, {{generateCustomizeString('customizeIconSize')}}</div>
      </el-upload>
    </el-form-item>

    <div v-if="!this.categoriesForm.parent_id">
      <el-form-item :label="generateCustomizeString('menuOperation')" prop="is_nav">
        <el-switch v-model="categoriesForm.is_nav">
        </el-switch>
      </el-form-item>
      <el-form-item :label="generateCustomizeString('pcMenu')" prop="is_pc_menu">
        <el-switch v-model="categoriesForm.is_pc_menu">
        </el-switch>
      </el-form-item>
      <el-form-item :label="generateCustomizeString('pcModel')" prop="is_pc_model">
        <el-switch v-model="categoriesForm.is_pc_model">
        </el-switch>
      </el-form-item>
      <el-form-item :label="generateCustomizeString('isAgentVisible')" prop="is_agent_visible">
        <el-switch v-model="categoriesForm.is_agent_visible">
        </el-switch>
      </el-form-item>
    </div>

    <el-form-item>
      <el-button v-if="isEdit" type="primary" @click="submitForm('categoriesForm')" plain>{{generateCustomizeString('update')}} </el-button>
      <el-button v-if="!isEdit" type="primary" @click="submitForm('categoriesForm')">{{generateCustomizeString('create')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

const defaultCategories = {
  name: '',
  parent_id: '',
  desc: '',
  sort_by: 0,
  icon_name: '',
  is_nav: false,
  is_agent_visible: true,
  is_index: false,
  is_pc_menu: true,
  is_pc_model: false,
  icon_img_key: '',
  pc_home_img_key: '',
  mobile_category_img_key: ''
}

export default {
  name: 'CategoriesDetail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      categoriesData: {},
      categoriesForm: Object.assign({}, defaultCategories),
      fetchLoding: false,
      pcHomeImgUrl: '',
      mobileImgUrl: '',
      iconImgUrl: '',
      qiniuData: {
        token: ''
      },
      customizeIconChecked: false,
      uploadIconShow: false,
      iconOptions: [
        {
          value: 'icon-naifen',
          label: '图标1',
          class: 'iconfont icon-naifen'
        },
        {
          value: 'icon-muyingshipin',
          label: '图标2',
          class: 'iconfont icon-muyingshipin'
        },
        {
          value: 'icon-muying',
          label: '图标3',
          class: 'iconfont icon-muying'
        },
        {
          value: 'icon-baojianpin',
          label: '图标4',
          class: 'iconfont icon-baojianpin'
        },
        {
          value: 'icon-yingyangpinbaojianpin',
          label: '图标5',
          class: 'iconfont icon-yingyangpinbaojianpin'
        },
        {
          value: 'icon-huazhuangpin',
          label: '图标6',
          class: 'iconfont icon-huazhuangpin'
        },
        {
          value: 'icon-unie642',
          label: '图标7',
          class: 'iconfont icon-unie642'
        },
        {
          value: 'icon-unie644',
          label: '图标8',
          class: 'iconfont icon-unie644'
        },
        {
          value: 'icon-baojian',
          label: '图标9',
          class: 'iconfont icon-baojian'
        },
        {
          value: 'icon-muyingwanju',
          label: '图标10',
          class: 'iconfont icon-muyingwanju'
        },
        {
          value: 'icon-lingshi',
          label: '图标11',
          class: 'iconfont icon-lingshi'
        },
        {
          value: 'icon-yifuhuanfu',
          label: '图标12',
          class: 'iconfont icon-yifuhuanfu'
        },
        {
          value: 'icon-jinkouxiuxianshipin',
          label: '图标13',
          class: 'iconfont icon-jinkouxiuxianshipin'
        },
        {
          value: 'icon-jiushuishouru',
          label: '图标14',
          class: 'iconfont icon-jiushuishouru'
        },
        {
          value: 'icon-weibiaoti2fuzhi12',
          label: '图标15',
          class: 'iconfont icon-weibiaoti2fuzhi12'
        },
        {
          value: 'icon-baojianpin1',
          label: '图标16',
          class: 'iconfont icon-baojianpin1'
        },
        {
          value: 'icon-shuiguo',
          label: '图标17',
          class: 'iconfont icon-shuiguo'
        },
        {
          value: 'icon-wanju',
          label: '图标18',
          class: 'iconfont icon-wanju'
        },
        {
          value: 'icon-jinkoushengxianmeishi',
          label: '图标19',
          class: 'iconfont icon-jinkoushengxianmeishi'
        },
        {
          value: 'icon-naifen1',
          label: '图标20',
          class: 'iconfont icon-naifen1'
        },
        {
          value: 'icon-jiudiancanting-',
          label: '图标21',
          class: 'iconfont icon-jiudiancanting-'
        },
        {
          value: 'icon-jiudian1',
          label: '图标22',
          class: 'iconfont icon-jiudian1'
        },
        {
          value: 'icon-jiudian',
          label: '图标23',
          class: 'iconfont icon-jiudian'
        },
        {
          value: 'icon-yaopin1',
          label: '图标24',
          class: 'iconfont icon-yaopin1'
        },
        {
          value: 'icon-yaopian',
          label: '图标25',
          class: 'iconfont icon-yaopian'
        },
        {
          value: 'icon-5',
          label: '图标26',
          class: 'iconfont icon-5'
        },
        {
          value: 'icon-yaopin',
          label: '图标27',
          class: 'iconfont icon-yaopin'
        },
        {
          value: 'icon-shu3',
          label: '图标28',
          class: 'iconfont icon-shu3'
        },
        {
          value: 'icon-shu2',
          label: '图标29',
          class: 'iconfont icon-shu2'
        },
        {
          value: 'icon-shu1',
          label: '图标30',
          class: 'iconfont icon-shu1'
        },
        {
          value: 'icon-shu',
          label: '图标31',
          class: 'iconfont icon-shu'
        },
        {
          value: 'icon-chongwu',
          label: '图标32',
          class: 'iconfont icon-chongwu'
        },
        {
          value: 'icon-gou',
          label: '图标33',
          class: 'iconfont icon-gou'
        },
        {
          value: 'icon-maomi',
          label: '图标34',
          class: 'iconfont icon-maomi'
        },
        {
          value: 'icon-cheliangguanli',
          label: '图标35',
          class: 'iconfont icon-cheliangguanli'
        },
        {
          value: 'icon-qicheqianlian-',
          label: '图标36',
          class: 'iconfont icon-qicheqianlian-'
        },
        {
          value: 'icon-typecar111',
          label: '图标37',
          class: 'iconfont icon-typecar111'
        },
        {
          value: 'icon-icon',
          label: '图标38',
          class: 'iconfont icon-icon'
        },
        {
          value: 'icon-ditan',
          label: '图标39',
          class: 'iconfont icon-ditan'
        },
        {
          value: 'icon-weijin',
          label: '图标40',
          class: 'iconfont icon-weijin'
        },
        {
          value: 'icon-shenghuoyongpin-',
          label: '图标41',
          class: 'iconfont icon-shenghuoyongpin-'
        },
        {
          value: 'icon-maoyi',
          label: '图标42',
          class: 'iconfont icon-maoyi'
        },
        {
          value: 'icon-Kitchen',
          label: '图标43',
          class: 'iconfont icon-Kitchen'
        },
        {
          value: 'icon-112',
          label: '图标44',
          class: 'iconfont icon-112'
        },
        {
          value: 'icon-xiyiji',
          label: '图标45',
          class: 'iconfont icon-xiyiji'
        },
        {
          value: 'icon-thermometer_icon',
          label: '图标46',
          class: 'iconfont icon-thermometer_icon'
        },
        {
          value: 'icon-xingzhuang',
          label: '图标47',
          class: 'iconfont icon-xingzhuang'
        },
        {
          value: 'icon-shipin',
          label: '图标48',
          class: 'iconfont icon-shipin'
        },
        {
          value: 'icon-xinpin',
          label: '图标49',
          class: 'iconfont icon-xinpin'
        },
        {
          value: 'icon-temai',
          label: '图标50',
          class: 'iconfont icon-temai'
        },
        {
          value: 'icon-liangcai',
          label: '图标51',
          class: 'iconfont icon-liangcai'
        },
        {
          value: 'icon-haixian',
          label: '图标52',
          class: 'iconfont icon-haixian'
        },
        {
          value: 'icon-mianshi',
          label: '图标53',
          class: 'iconfont icon-mianshi'
        },
        {
          value: 'icon-jirou',
          label: '图标54',
          class: 'iconfont icon-jirou'
        },
        {
          value: 'icon-zhurou',
          label: '图标55',
          class: 'iconfont icon-zhurou'
        },
        {
          value: 'icon-niurou',
          label: '图标56',
          class: 'iconfont icon-niurou'
        },
        {
          value: 'icon-jiaozi',
          label: '图标57',
          class: 'iconfont icon-jiaozi'
        },
        {
          value: 'icon-baozi',
          label: '图标58',
          class: 'iconfont icon-baozi'
        },
        {
          value: 'icon-haixian1',
          label: '图标59',
          class: 'iconfont icon-haixian1'
        },
        {
          value: 'icon-tang-',
          label: '图标60',
          class: 'iconfont icon-tang-'
        },
        {
          value: 'icon-xia1',
          label: '图标61',
          class: 'iconfont icon-xia1'
        },
        {
          value: 'icon-shucai',
          label: '图标62',
          class: 'iconfont icon-shucai'
        },
        {
          value: 'icon-congeex',
          label: '图标63',
          class: 'iconfont icon-congeex'
        },
        {
          value: 'icon-dianxin',
          label: '图标64',
          class: 'iconfont icon-dianxin'
        }
      ],
      icon_name: '',
      rules: {
        name: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        desc: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        sort_by: [
          {
            required: true,
            // type: 'number',
            // pattern: '^[0-9]',
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        icon_name: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    generateCustomizeString,
    setInt(event) {
      if (this.categoriesForm.sort_by == '' || this.categoriesForm.sort_by == null) {
        this.categoriesForm.sort_by = 0
      }
      this.categoriesForm.sort_by = (parseInt(this.categoriesForm.sort_by) > 999) ? 999 : parseInt(this.categoriesForm.sort_by)
    },
    submitForm(formName) {
      if (this.isEdit) {
        this.updateCategory()
      } else {
        this.createCategory()
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    fetchCategories() {
      if (this.fetchLoding) return
      this.fetchLoding = true
      request({
        url: '/categories',
        method: 'get'
      })
        .then(response => {
          const data = response.data
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.name = response.data[i].name
            obj.categoriesDetail = response.data[i].desc
            obj.sort_by = response.data[i].sort_by
            obj.icon_name = response.data[i].icon_name
            obj.is_agent_visible = response.data[i].is_agent_visible
            // obj.is_nav = response.data[i].is_nav
            const sub = response.data[i].sub_categories
            for (let j = 0; j < response.data[i].sub_categories.length; j++) {
              var sobj = {}
              sobj.id = response.data[i].sub_categories[j].id
              sobj.name = response.data[i].sub_categories[j].name
              sobj.categoriesDetail = response.data[i].sub_categories[j].desc
              sobj.sort_by = response.data[i].sub_categories[j].sort_by
              sub[j] = sobj
            }
            obj.children = sub
            data[i] = obj
          }

          this.categoriesData = data
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.fetchLoding = false
        })
    },
    fetchCategory() {
      request({
        url: 'category/' + this.$route.params.categoryId,
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            for (const i in this.categoriesForm) {
              this.categoriesForm[i] = res.data[i]
              if (i === 'is_nav' || i === 'is_index' || i === 'is_pc_menu' || i === 'is_pc_model') {
                this.categoriesForm[i] = res.data[i] === 1
              }
              if (i === 'is_agent_visible') {
                this.categoriesForm[i] = res.data[i] === 1
              }
              if (res.data['icon_img_key']) {
                this.iconImgUrl = 'https://img.nzmai.com.cn/' + res.data['icon_img_key']
                this.customizeIconChecked = true
                this.uploadIconShow = true
              }
              if (res.data['pc_home_img_key']) {
                this.pcHomeImgUrl = 'https://img.nzmai.com.cn/' + res.data['pc_home_img_key']
              }
              if (res.data['mobile_category_img_key']) {
                this.mobileImgUrl = 'https://img.nzmai.com.cn/' + res.data['mobile_category_img_key']
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.fetchLoding = false
        })
    },
    createCategory() {
      if (this.categoriesForm.sort_by == '' || this.categoriesForm.sort_by == null) {
        this.categoriesForm.sort_by = 0
      }
      var data = {
        name: this.categoriesForm.name,
        desc: this.categoriesForm.desc,
        sort_by: this.categoriesForm.sort_by,
        parent_id: this.categoriesForm.parent_id,
        icon_name: this.categoriesForm.icon_name ? this.categoriesForm.icon_name : 'icon-baojian',
        is_nav: this.categoriesForm.is_nav,
        is_index: this.categoriesForm.is_index,
        is_agent_visible: this.categoriesForm.is_agent_visible,
        is_pc_menu: this.categoriesForm.is_pc_menu,
        is_pc_model: this.categoriesForm.is_pc_model,
        icon_img_key: this.categoriesForm.icon_img_key,
        pc_home_img_key: this.categoriesForm.pc_home_img_key,
        mobile_category_img_key: this.categoriesForm.mobile_category_img_key
      }
      request({
        url: 'category',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('categoryCreated'),
              type: 'success'
            })

            this.$store.dispatch('delCurrentViews', {
              view: this.$route,
              $router: this.$router
            })
            this.$router.replace({ name: 'Categories' })
          } else {
            this.$message.error(this.generateCustomizeString('categoryCreateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('categoryCreateFailed'))
        })
    },
    updateCategory() {
      if (this.categoriesForm.sort_by == '' || this.categoriesForm.sort_by == null) {
        this.categoriesForm.sort_by = 0
      }
      const data = this.categoriesForm
      request({
        url: 'category/' + this.$route.params.categoryId,
        method: 'put',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })

            this.$router.replace({ name: 'Categories' })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
    },
    fetchUploadToken() {
      return new Promise((resolve, reject) => {
        request({
          url: '/upload-token',
          method: 'get'
        })
          .then(res => {
            this.qiniuData.token = res.data['token']
            resolve()
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    handleAvatarSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.categoriesForm.pc_home_img_key = res.key

      this.pcHomeImgUrl = 'https://img.nzmai.com.cn/' + res.key
    },
    handleMobileAvatarSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.categoriesForm.mobile_category_img_key = res.key

      this.mobileImgUrl = 'https://img.nzmai.com.cn/' + res.key
    },
    handleError(res) {
      // 显示错误
      console.log(res)
    },
    beforeAvatarUpload(file) {
      // 在图片提交前进行验证
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error(this.generateCustomizeString('jpgpngonly'))
      }
      if (!isLt2M) {
        this.$message.error(this.generateCustomizeString('lessThan2MB'))
      }

      return (isJPG || isPNG) && isLt2M
    },
    selectCategoryIcon() {
      if (this.categoriesForm.icon_name !== '' || this.categoriesForm.icon_name !== this.generateCustomizeString('customization')) {
        this.customizeIconChecked = false
        this.uploadIconShow = false
      }
    },
    handleCustomizeIcon() {
      if (this.customizeIconChecked === true) {
        this.categoriesForm.icon_name = this.generateCustomizeString('customization')
        this.uploadIconShow = true
      } else {
        this.categoriesForm.icon_name = ''
        this.uploadIconShow = false
      }
    },
    handleCustomizeIconSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.categoriesForm.icon_img_key = res.key

      this.iconImgUrl = 'https://img.nzmai.com.cn/' + res.key
    },
    deletePcImage() {
      this.categoriesForm.pc_home_img_key = ''
      this.pcHomeImgUrl = ''
    },
    deleteMobileImage() {
      this.categoriesForm.mobile_category_img_key = ''
      this.mobileImgUrl = ''
    }
  },
  created() {
    Promise.all([
      this.fetchUploadToken()
    ])
      .then(result => {
        this.fetchCategories()
        if (this.isEdit) {
          this.fetchCategory()
        } else {
          this.categoriesForm = Object.assign({}, defaultCategories)
        }
      })
      .catch(error => {
        console.warn(error)
      })
  },
  computed: {
    displayCategorie() {
      return 'sdf'
    },
    displayPcHomeCategoryImg() {
      return this.pcHomeImgUrl + '?imageView2/0/w/360/h/200/q/75|imageslim'
    },
    displayMobileCategoryImg() {
      return this.mobileImgUrl + '?imageView2/0/w/360/h/200/q/75|imageslim'
    },
    displayIconImg() {
      return this.iconImgUrl + '?imageView2/0/w/360/h/200/q/75|imageslim'
    }
  }
}
</script>

<!-- <style type="text/css" src="https://at.alicdn.com/t/font_620894_9wmdbtsgafmt2o6r.css"></style> -->
<style rel="stylesheet/scss" lang="scss" scoped >

.demo-categoriesForm {
  padding: 50px 50px 0px 50px;
}
.select_icon {
  display: none;
}

</style>
